export default __webpack_public_path__ + "static/media/element_33.b8ed51a9.jpg";